<template>
  <div class="contentGlobal">
    <div class="listContainer">
      <div class="pTop">
        <b-row>
          <b-col cols="3" class="inputSearch">
            <b-input-group>
              <!-- Type to Search -->
              <b-form-input v-model="filter" :placeholder="$t('messages.typeToSearch')"/>
              <b-input-group-append>
                <b-btn :disabled="!filter" @click="cancelFilter()">
                  <icon name="times-circle"></icon>
                </b-btn>
              </b-input-group-append>
            </b-input-group>
          </b-col>
          <b-col cols="3" class="inputSearch">
            <select class="form-control" v-model="searchOn">
              <option
                v-for="option in searchFields"
                :key="option.value"
                v-bind:value="option.value"
                :selected="true"
              >{{ option.name }}</option>
            </select>
          </b-col>
          <b-col cols="2" class="inputSearch contBtn">
            <!-- Search -->
            <b-btn :disabled="!filter" @click="onFilter()">{{ $t("messages.search") }}</b-btn>
          </b-col>
        </b-row>
        <div>
          <b-row class="pt-4" cols="12">
            <b-table ref="table"
              class="poolTable"
              :fields="fields"
              :items="rows"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
              :current-page="currentPage"
              :per-page="paging.users_per_page"
              head-variant="light"
              hover striped
            >
              <template v-slot:cell(actions)="{ value, item }">
                <router-link style="color:#ffffff" target= '_blank' :to="`/user-detail/${item.id}`">
                  <icon name="edit"></icon>
                </router-link>
              </template>

              <template #cell(createdAt)="{ value }">
                {{ value | moment("DD-MM-YYYY HH:mm:ss") }}
              </template>

              <template #cell(company)="{ value }">{{ value | getCompanyName }}</template>

              <template #cell(pools)="{ value }"
              >{{ (value) ? value.length : 0 }}</template>
            </b-table>
          </b-row>
          <b-row align-h="center">
            <el-pagination
                class="pagination"
                :page-size="paging.users_per_page"
                layout="prev, pager, next"
                :current-page="currentPage"
                :total="count"
                @current-change="handleCurrentChange"
              >
            </el-pagination>
          </b-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState} from 'vuex'
const fb = require('../firebaseConfig.js')

export default {

    data() {
      return {
        count : null,
        sortBy: null,
        sortDesc: false,
        sortDirection: 'desc',
     
        filter: null,
        searchOn: 'email',
        searchFields:[
            {value: 'email', name: this.$i18n.t("messages.login.email")},
            {value: 'name', name: this.$i18n.t("messages.login.name")}
        ],
        rows: [],  
        fields: [
            { key: 'email', label: this.$i18n.t("messages.login.email"),t: "messages.login.email"},
            { key: 'name', label: this.$i18n.t("messages.login.name"), t: "messages.login.name"},
            { key: 'company', label: this.$i18n.t("messages.company"), t: "messages.company"},
            { key: 'phone', label: this.$i18n.t("messages.login.phone"), t: "messages.login.phone"},
            { key: 'pools', label: this.$i18n.t("messages.assignedPools"), t: "messages.assignedPools"},
            { key: 'language', label: this.$i18n.t("messages.language"), t: "messages.language"},
            { key: 'createdAt', label: this.$i18n.t("messages.createdAt"), t: "messages.createdAt"},
            { key: 'actions', label: this.$i18n.t("messages.actions"), t: "messages.actions" }
        ],
        paging: {
            users_per_page: 15,
            loading: false, 
            loaded: [] 
        },  
        ref: {
            rows: null, 
        }
      }
    },
    mounted() {
      window.addEventListener('keyup', this.onKeyEnter);
    },
    created() {
        const page = this.$route.query.page || 1;
        this.init();
    },
    watch: {
      "$i18n.locale": function(oldV, newV) {
        this.resetColumns();
      },
      currentPage: function(oldV, newV){
        this.onPageChange(oldV)
      }
    },
    computed: {
        ...mapState(['userProfile']),
  
      currentPage: {
        get() {
          return Number(this.$route.query.page) || 1;
        },
        set(newPage) {
          this.$router.push({ query: { ...this.$route.query, page: newPage } })
        }
      }

    },
    methods: {
      onKeyEnter(event){
        if (event.keyCode === 13) { 
            if(this.filter){
              this.onFilter();
            }
        }
      },
      handleCurrentChange(val) {
        this.currentPage = val
      },
      resetColumns() {
        this.$refs.table.fields.forEach(column => {
          if (column.t) {
            column.label = this.$i18n.t(column.t);
          }
        });
      },
      cancelFilter() {
          this.filter = null
          this.paging.loaded = []
          this.init();
      },
      onFilter() {
          this.rows = []
          if(!this.userProfile.isSuperAdmin){
              this.ref.rows = this.ref.rows.where('company', '==', this.userProfile.company)
          }

          this.ref.rows.orderBy(this.searchOn).startAt(this.filter).endAt(this.filter+'\uf8ff').get().then ( (user) =>{
              let rows = 0
              user.forEach((doc) => {
                  let userData = doc.data();
                  userData.id = doc.id;
                  this.rows.push(userData);
                  rows++;
              });
              this.count = rows;
              this.currentPage=1
          })
      },
      init () {
        this.ref.rows = fb.usersCollection
        if(this.userProfile.isSuperAdmin){
            fb.countersCollection.doc('users').get().then((res) => {
                this.count = res.data().numberOfDocs
                this.rows = new Array(this.count).fill({loading: true});
                this.onPageChange(this.currentPage);
            })
        }else{
             fb.usersCollection.where('company', '==', this.userProfile.company).get().then((res) => {
                this.count = res.size
                this.rows = new Array(this.count).fill({loading: true});
                this.onPageChange(this.currentPage);
             })  
        }
      },
      handleUsers (ref, index = 0) {
          return new Promise((resolve, reject) => {
              ref.get().then((documentSnapshots) => {
                  let _rows = [],
                  _index = index || 0;
          
                  documentSnapshots.forEach((doc) => {
                      let userData = doc.data();
                      userData.id = doc.id;
                      _rows.push(userData);
                      this.$set(this.rows, _index, {
                          loading: false,
                          ...userData
                      });
                      _index++;
                  });
                  resolve(documentSnapshots);
              });
          });
      },
      async onPageChange (toPage, fromPage) {
          const currentPage = toPage,
          per_page = this.paging.users_per_page;
          
          let startAfter = null,
              limit = per_page,
              index = per_page * (currentPage - 1), 
              startAfterAvailable;
          
          if (this.paging.loaded.includes(currentPage)) {
              return;
          };
          
          const itemBefore = this.rows[index - 1];
          if(!this.userProfile.isSuperAdmin){
              this.ref.rows = this.ref.rows.where('company', '==', this.userProfile.company)
          }
          if (itemBefore && !itemBefore.loading) {
              const itemBeforeRef = fb.usersCollection.doc(itemBefore.id),
              itemBeforeSnapshot = await itemBeforeRef.get();
      
          
              startAfter = this.ref.rows.startAfter(itemBeforeSnapshot).limit(per_page);
              if (index < 0) {
                  index = 0;
              };
              startAfterAvailable = true;
          }
          else {
              limit = currentPage * per_page;  
              if (limit <= 0) {
                  limit = per_page;
              };

              startAfter = this.ref.rows.limit(limit);
              index = 0;   /* Start loop from first page */
              startAfterAvailable = false;
          };
          
          this.handleUsers(startAfter, index).then((documentSnapshots) => {
              this.paging.loading = false;
              if (startAfterAvailable) {
                  this.paging.loaded.push(currentPage);
              }
              else {
                  this.paging.loaded = Array.from(Array(currentPage).keys());
              };
          })
      },
    },
    filters:{
      getCompanyName: (value) => {
        let companies =  [
          {code: 1, name:'Vistapool'},
          {code: 2, name:'Hayward'},
          {code: 3, name:'Naturally-salt'},
          {code: 4, name:'Da-gen'},
          {code: 5, name:'Kripsol'},
          {code: 6, name:'Brilix'}
        ]
        let val =  companies.find(x => x.code === value); 
        if(val){
            return val.name
        }  
      }
    }
}
</script>
<style> 
.pTop {
    padding-top: 80px;
}
</style>


// WEBPACK FOOTER //
// src/components/Users.vue